import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class CloudServiceIcon extends BaseIcon {
    getChildren = () => [<path fill={this.getColor()} style={{ fillRule: 'evenodd' }} d="M43.17,20.18a7.85,7.85,0,0,0-11.47-5.6,12.53,12.53,0,0,0-24.76,0A8.67,8.67,0,0,0,0,23.29a8.8,8.8,0,0,0,5.74,8.4,1.76,1.76,0,0,0,1.2.31H17V21.74A2.7,2.7,0,0,1,19.63,19H31.39A2.68,2.68,0,0,1,34,21.71V32h8a5.89,5.89,0,0,0,6-5.91A6,6,0,0,0,43.17,20.18Z"/>,
    <path fill={this.getColor()} d="M31.37,44H28.5V42.5h-6V44H19.63A1.67,1.67,0,0,1,18,42.29V21.71A1.67,1.67,0,0,1,19.63,20H31.37A1.67,1.67,0,0,1,33,21.71h0V42.28A1.68,1.68,0,0,1,31.37,44ZM31,28H20v1H31Zm0-3H20v1H31Z"/>
    ]
    getViewBox = () => '0 0 48 48'
}
